import { atom, selector } from 'recoil'
import Fuse from 'fuse.js'
import { keyFactory } from 'src/utils/recoil'
import { AMBrand, AMMobilityLocationRankList } from 'src/common-services'
import * as brandsAtoms from 'src/atoms/brands'

const key = keyFactory('brands-rank-layer')

export const active = atom<boolean>({
  key: key('active'),
  default: false,
})

export const showLayer = selector<boolean>({
  key: key('show-layer'),
  get: ({ get }) => {
    const _active = get(active)
    const brands = get(selectedBrands)
    return _active && brands.length > 0
  },
})

export const selectedBrands = atom<AMBrand[]>({
  key: key('selected'),
  default: [],
})

export const filter = atom<string>({
  key: key('filter'),
  default: '',
})

export const selectedLocationByBrand = atom<Record<string, AMMobilityLocationRankList | undefined>>({
  key: key('selected-location-by-brand'),
  default: {},
})

const searchableBrands = selector<Fuse<AMBrand>>({
  key: key('searchable-brands'),
  get: async ({ get }) => {
    const amBrands = get(brandsAtoms.amBrands)
    return new Fuse(amBrands, { keys: ['name'], threshold: 0.2 })
  },
})

const brands = selector<AMBrand[]>({
  key: key('brands'),
  get: async ({ get }) => {
    const _filter = get(filter)
    if (!_filter) {
      return []
    }

    const allBrands = get(searchableBrands)
    return allBrands
      .search(_filter)
      .slice(0, 10)
      .map((r) => r.item)
  },
})

export const filteredBrands = selector<AMBrand[]>({
  key: key('filtered-brands'),
  get: async ({ get }) => {
    const _selectedBrands = get(selectedBrands)
    const _brands = get(brands)

    return _brands.filter((b) => !_selectedBrands.find((sb) => sb.id === b.id))
  },
})
